import { useState } from 'react';

import { FormattedMessage } from 'react-intl';

import AvatarGroup from '@atlaskit/avatar-group';
import Button from '@atlaskit/button/new';
import { Inline, Stack, Text, xcss } from '@atlaskit/primitives';

import { useRelationshipsAnalytics } from '../../hooks';
import { Engineer } from '../../types';
import { BaseCard } from '../base-card';
import { RequestAssistanceModal } from '../request-assistance-modal';

import { messages } from './messages';

const contentStyles = xcss({
	height: '100%',
});

interface SupportEngineersCardProps {
	engineers: Engineer[];
}

export const SupportEngineersCard = ({ engineers }: SupportEngineersCardProps) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { sendRequestAssistanceButtonClickUIEvent } = useRelationshipsAnalytics();

	const handleRequestAssistanceClick = () => {
		sendRequestAssistanceButtonClickUIEvent();
		setIsModalOpen(true);
	};

	const shouldRenderAvatarGroup = engineers.some(({ imageUrl }) => imageUrl !== '');

	const avatarGroupData = shouldRenderAvatarGroup
		? engineers
				.map(({ id, name, imageUrl }) => ({
					key: id,
					name: name,
					href: '#',
					src: imageUrl,
				}))
				.sort((a, b) => b.src.localeCompare(a.src))
		: [];

	return (
		<BaseCard message={messages.supportEngineersCardTitle}>
			<Stack xcss={contentStyles} space="space.100" spread="space-between">
				<Text>
					<FormattedMessage {...messages.supportEngineersCardSubtitle} />
				</Text>
				{shouldRenderAvatarGroup ? (
					<AvatarGroup size="large" data={avatarGroupData} />
				) : (
					<Text>
						<FormattedMessage {...messages.supportEngineersCardMessageWhenNoAvaters} />
					</Text>
				)}
				<Inline>
					<RequestAssistanceModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
					<Button onClick={handleRequestAssistanceClick}>
						<FormattedMessage {...messages.supportEngineersCardButtonText} />
					</Button>
				</Inline>
			</Stack>
		</BaseCard>
	);
};
